import { createAsyncThunk } from '@reduxjs/toolkit';

import { UpdateBrandFilterRequest } from 'src/services/apiInterfaces';
import * as APIv1 from 'src/services/apiV1';

export const updateUserBrandFilter = createAsyncThunk(
  'brandFilter/updateUserBrandFilter',
  ({
    brandFilterRequest,
    userId,
  }: {
    brandFilterRequest: UpdateBrandFilterRequest;
    userId: string;
  }) => APIv1.updateUserBrandFilter(userId, brandFilterRequest),
);
